import { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import loadConfig from "../../../Services/Api/ApiServices";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import AddEditBudgetItem from "./AddEditBudgetItem";
import { DeleteBudgetItems } from "../../../Redux/Reducers/ReportStage/BudgetItems";

const BudgetItem = (props) => {
  const [jsonData, setJsonData] = useState({});
  const [newAdded,setnewAdded]=useState(false)
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [budgetItemsId, setbudgetItemsId] = useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const UpdateBudgetItems = useSelector(
    (state) => state.BudgetItems.UpdateBudgetItems
  );
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "typeName",
      ShowStatus: true,
      NmaeColumn: "نوع البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemName",
      ShowStatus: true,
      NmaeColumn: "اسم البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemDescription",
      ShowStatus: true,
      NmaeColumn: "وصف البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "numberOfUnits",
      ShowStatus: true,
      NmaeColumn: "عدد الوحدات",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "unitPrice",
      ShowStatus: true,
      NmaeColumn: "سعر الوحدة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "newAddedAttachmentName",
      ShowStatus: true,
      NmaeColumn: "مرفق التعديل الميزاني للبند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      FileCostume:true,
      typeColumn: "file",
    },
    {
      KeyName: "total",
      ShowStatus: true,
      NmaeColumn: "المجموع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
  ];
  const M_ApplicationsBtns = [
    // {
    //   Click: async (e) => {
    //     setsubObjectivesId(e.target.value);
    //     console.log(e.target.value, "sssssssssssss");
    //     setPopUpBodyOPjectDataStatus(true);
    //   },
    //   content: "",
    //   className: "bi bi-view-list",

    //   id: "editBtn",
    //   title: "عرض",
    //   ShowStatus: true,
    // },
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        setnewAdded(objects.newAdded);
        // console.log(objects,"ssssssssssssssssssssssssssdw");
        
        setbudgetItemsId(objects.budgetItemsId);
        // console.log(e.target.value, "sssssssssssss");

        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: "bi bi-pencil-square",

      id: "editBtn",
      title: "عرض",
      ShowStatus: !props.disabled,
    },
    {
      Click: async (e) => {
          var objects = JSON.parse(e.target.value);
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteBudgetItems({ budgetItemsId: objects.budgetItemsId })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      // ShowStatus: !shouldDisableFields,

      ShowStatus: !props.disabled,
      // ShowStatus: true,
      //   !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        {
          <AddEditBudgetItem
            newAdded={true}
            canEdit="add"
            reportId={props.reportId}
          />
        }
      </div>
    ),
    title: "بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditBudgetItem
          newAdded={newAdded}
          reportId={props.reportId}
          budgetItemsId={budgetItemsId}
          canEdit="edit"
        />
      </div>
    ),
    title: "بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان ",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  useEffect(() => {
    dispatch(setRefreshTable());
  }, [UpdateBudgetItems]);

  return (
    <>
      <TableAHSF
        AllValueAction={true}
        RequestsManagerValue={true}
        culomEdite={culomEdite}
        uniqueValue={"budgetItemsId"}
        valueButtonAction={"budgetItemsId"}
        URL={`api/BudgetItems/BudgetItemsList`}
        UrlBody={{
          reportId: props.reportId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان "}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        // tableBtn={!shouldDisableFields}
        tableBtn={!props.disabled}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};
export default BudgetItem;
